<template>
  <div class="dashboard">
    <div class="dashboard__view">
      <router-view />
    </div>
    <nav class="dashboard__navigation">
      <span class="dashboard__navigation__title">{{
        ($store.state.user && $store.state.user.name) || ""
      }}</span>
      <router-link to="/konto/server" class="dashboard__navigation__link"
        ><b-icon
          icon="server"
          size="is-small"
          class="dashboard__navigation__link__icon"
        />
        Server</router-link
      >
      <router-link to="/konto/verbrauch" class="dashboard__navigation__link"
        ><b-icon
          icon="chart-bar"
          size="is-small"
          class="dashboard__navigation__link__icon"
        />
        Kosten</router-link
      >
      <router-link to="/konto/einstellungen" class="dashboard__navigation__link"
        ><b-icon
          icon="user-cog"
          size="is-small"
          class="dashboard__navigation__link__icon"
        />
        Einstellungen</router-link
      >
      <a href="#" @click="logout" class="dashboard__navigation__link"
        ><b-icon
          icon="sign-out-alt"
          size="is-small"
          class="dashboard__navigation__link__icon"
        />
        Abmelden</a
      >
    </nav>
    <b-loading :active.sync="loading" />
  </div>
</template>

<style scoped lang="scss">
.dashboard {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @include container;

  &__view {
    width: 80%;
  }

  &__navigation {
    width: 17.5%;

    display: flex;
    flex-direction: column;

    &__title {
      color: $text;
      text-align: center;
      margin: 0.5rem 0;
    }

    &__link {
      margin-top: 0.25rem;
      color: $text;
      padding: 0.5rem 0.75rem;
      border-radius: 5px;

      &:hover,
      &:focus {
        background: rgba(black, 0.1);
      }

      &.router-link-exact-active {
        background: $primary;
        color: #fff;
      }

      &__icon {
        vertical-align: middle;
        margin-bottom: 4px;
        margin-right: 4px;
      }
    }
  }

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    justify-content: flex-start;

    &__view {
      width: 100%;
    }

    &__navigation {
      margin: 0.5rem 0;
      width: 100%;
      flex-direction: row;

      &__title {
        display: none;
      }
      &__link {
        flex: 1;
        text-align: center;

        &:last-of-type {
          display: none;
        }

        &__icon {
          display: block;
          margin: 0 !important;
        }
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: true
    };
  },
  methods: {
    logout(keepautofill, next) {
      localStorage.removeItem("jwt");
      if (!keepautofill) localStorage.removeItem("autofill");
      this.$store.state.api.destroy();
      window.location.href = "/login" + (next ? "?next=" + next : "");
    },
    getUser() {
      this.$store.state.api.users
        .self()
        .then(response => {
          console.log(response.data);
          this.$store.commit("user", response.data);
          localStorage.setItem("autofill", this.$store.state.user.email);
          this.loading = false;
        })
        .catch(error => console.log(error));
    },
    getPricing() {
      this.$store.state.api.pricing
        .get()
        .then(response => {
          console.log(response.data);
          this.$store.commit("pricing", response.data);
        })
        .catch(error => console.log(error));
    }
  },
  beforeMount() {
    if (!localStorage.getItem("jwt"))
      this.logout(true, window.location.pathname);

    this.$store.state.api.setupWithToken(localStorage.getItem("jwt"));

    if (!this.$store.state.api.isTokenValid())
      this.logout(true, window.location.pathname);
  },
  mounted() {
    this.getUser();
    this.getPricing();
  }
};
</script>
